import { io } from 'socket.io-client';

const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || 'https://backend.edumetrix.uk';

class SocketService {
  constructor() {
    this.socket = null;
    this.connected = false;
  }

  connect(token) {
    if (this.socket?.connected) {
      return this.socket;
    }


    this.socket = io(SOCKET_URL, {
      auth: { token },
      transports: ['websocket', 'polling'],
        withCredentials: true,
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionAttempts: 5
    });

    this.socket.on('connect', () => {
      this.connected = true;
    });

    this.socket.on('disconnect', (reason) => {
      this.connected = false;
    });

    this.socket.on('connect_error', (error) => {
      this.connected = false;
    });

    return this.socket;
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
      this.connected = false;
    }
  }

  // Join a chat room
  joinChat(chatId) {
    if (this.socket?.connected) {
      this.socket.emit('join-chat', { chatId });
    } else {
      console.warn('Socket not connected, cannot join chat');
    }
  }

  // Leave a chat room
  leaveChat(chatId) {
    if (this.socket?.connected) {
      this.socket.emit('leave-chat', { chatId });
    }
  }

  // Listen for new messages
  onNewMessage(callback) {
    if (this.socket) {
      this.socket.on('newMessage', callback);
    }
  }

  // Remove new message listener
  offNewMessage() {
    if (this.socket) {
      this.socket.off('newMessage');
    }
  }

  // Listen for unread count updates
  onUnreadUpdate(callback) {
    if (this.socket) {
      this.socket.on('chatUnreadUpdate', callback);
    }
  }

  // Remove unread update listener
  offUnreadUpdate() {
    if (this.socket) {
      this.socket.off('chatUnreadUpdate');
    }
  }

  // Listen for typing indicators
  onTyping(callback) {
    if (this.socket) {
      this.socket.on('typing', callback);
    }
  }

  // Remove typing listener
  offTyping() {
    if (this.socket) {
      this.socket.off('typing');
    }
  }

  // Emit typing event
  sendTyping(chatId, typing) {
    if (this.socket?.connected) {
      this.socket.emit('typing', { chatId, typing });
    }
  }

  isConnected() {
    return this.connected && this.socket?.connected;
  }

  getSocket() {
    return this.socket;
  }
}

// Create singleton instance
const socketService = new SocketService();

export default socketService;
